import { HTTPURL } from '../constants/Matcher';

export async function get_grade() {
    try {
        const response = await fetch(HTTPURL + 'api/grades-all');
        const responseData = await response.json();
        if (responseData.status) {
            // responseData?.message;
        }
        // else {
        //    responseData?.message;
        // }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


export async function get_course() {
    try {
        const response = await fetch(HTTPURL + 'api/courses-all');
        const responseData = await response.json();
        // if (responseData.status) {
        //     responseData?.message;
        // } else {
        //    responseData?.message;
        // }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// get all days
export async function get_states() {
    try {
        const response = await fetch(HTTPURL + 'api/state-all');
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        return error.message;
    }
}

// get all branches
export async function state_branch_all(id) {
    try {
        const response = await fetch(HTTPURL + `api/state-branches?branch_state=${id}`);
        const responseData = await response.json();
        if(responseData.status)
        {
            // toast.success(responseData?.message);
        } else {
            //toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

export async function get_branch() {
    try {
        const response = await fetch(HTTPURL + 'api/branches-all');
        const responseData = await response.json();
        // if (responseData.status) {
        //   responseData?.message;
        // } else {
        //     responseData?.message;
        // }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

export async function get_term(year) {
    try {
        const response = await fetch(HTTPURL + `api/year-terms-all2?year=${year}`);
        const responseData = await response.json();
        // if (responseData.status) {
        //   responseData?.message;
        // } else {
        //     responseData?.message;
        // }
        console.log('countery',responseData.data[0].id);
        return responseData;
    
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}




export async function get_country() {
    try {
        const response = await fetch(HTTPURL + 'api/countries-all');
        const responseData = await response.json();
        // if (responseData.status) {
        //   responseData?.message;
        // } else {
        //     responseData?.message;
        // }
        console.log('countery',responseData.data[0].id);
        return responseData;
    
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}



export async function get_state(countryId) {
    try {
        const response = await fetch(HTTPURL + `api/states-all?id=${countryId}`);
        const responseData = await response.json();
        // if (responseData.status) {
        //   responseData?.message;
        // } else {
        //     responseData?.message;
        // }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// get all subjects 
export async function subject_all()
{
    try {
        const response = await fetch(HTTPURL + 'api/subject-all');
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// get all course type
export async function course_type_all()
{
    try {
        const response = await fetch(HTTPURL + 'api/course-type-all');
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// get subject by grade id 
export async function subject_by_grade_id(id)
{
    try {
        const response = await fetch(HTTPURL + `api/get-subject-by-grade/?id=${id}`);
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


// get insert id
export async function insertId() {
    try {
        const response = await fetch(HTTPURL + `api/get-last-insert-id`);
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        return error.message;
    }
}
